import { render, staticRenderFns } from "./ProjectsForm.vue?vue&type=template&id=68a98747&"
import script from "./ProjectsForm.vue?vue&type=script&lang=ts&"
export * from "./ProjectsForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectsForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports